<div class="sidebar" style="-webkit-overflow-scrolling: touch; transform: translate3d(0,0,0);">
  <!-- Booking Section -->
  <div class="card mb-xl-20" style="position: relative; z-index: 1001;">
    <div class="card-header padding-15 fw-700">
      <h3 class="text-light-black mb-0">Book Appointment</h3>
    </div>
    <div class="card-body padding-15">
      <!-- Loading State -->
      <div
        *ngIf="isLoadingStore || isLoadingServices"
        class="text-center"
        style="padding: 20px"
      >
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <p class="text-light-black mt-2" style="font-size: 14px">Loading...</p>
      </div>

      <!-- Booking Form -->
      <div *ngIf="!isLoadingStore && !isLoadingServices">
        <!-- Date Selection -->
        <div class="mb-4">
          <label class="text-light-black fw-600 mb-2 d-block"
            >Select Date</label
          >
          <input
            type="date"
            class="form-control form-control-submit"
            [min]="getMinDate()"
            [value]="selectedDate ? formatDateForInput(selectedDate) : ''"
            (change)="onDateChange($event)"
          />
        </div>

        <!-- Time Selection -->
        <div *ngIf="selectedDate" class="mb-4">
          <label class="text-light-black fw-600 mb-2 d-block"
            >Available Times</label
          >
          <div *ngIf="availableTimes.length === 0" class="text-center p-3">
            <p class="text-light-white fs-12 mb-0">
              No available times for this date
            </p>
          </div>
          <div *ngIf="availableTimes.length > 0" class="d-flex flex-wrap gap-2">
            <button
              *ngFor="let time of availableTimes"
              type="button"
              class="btn btn-sm"
              [class.btn-primary]="selectedTime === time"
              [class.btn-outline-primary]="selectedTime !== time"
              (click)="onTimeSelect(time)"
              (touchend)="onTimeSelect(time); $event.preventDefault()"
              style="min-width: 80px; cursor: pointer; touch-action: manipulation;"
            >
              {{ time }}
            </button>
          </div>
        </div>
        <!-- Selected Services List -->
        <div *ngIf="selectedServices.length === 0" class="mb-4 text-center p-3">
          <p class="text-light-white fs-12 mb-0">
            No services selected. Add services from the store page.
          </p>
        </div>
        <div *ngIf="selectedServices.length > 0" class="mb-4">
          <label class="text-light-black fw-600 mb-2 d-block"
            >Selected Services</label
          >
          <div
            *ngFor="let selectedService of selectedServices"
            class="mb-3 p-3 bg-light rounded"
          >
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <p class="text-light-black fw-600 mb-1">
                  {{ selectedService.serviceName }}
                </p>
                <p class="text-light-white fs-12 mb-0">
                  {{ formatPrice(selectedService.price) }} •
                  {{ formatDuration(selectedService.duration) }}
                </p>
              </div>
              <button
                type="button"
                class="btn btn-sm text-danger p-0"
                (click)="removeService(selectedService.serviceId)"
                (touchend)="removeService(selectedService.serviceId); $event.preventDefault()"
                style="background: none; border: none; cursor: pointer; padding: 10px !important;"
              >
                <i class="far fa-times-circle"></i>
              </button>
            </div>

            <!-- Staff Selection for this Service -->
            <div>
              <div class="form-group">
                <label class="text-light-black fs-12 mb-1 d-block"
                  >Select Staff</label
                >
                <select
                  class="form-control form-control-submit"
                  [ngModel]="selectedService.staffId"
                  (ngModelChange)="
                    onStaffSelect(selectedService.serviceId, $event)
                  "
                  [disabled]="!selectedDate || !selectedTime || isLoadingAvailability"
                  style="-webkit-appearance: none; appearance: none; cursor: pointer;"
                  (touchstart)="$event.stopPropagation()"
                >
                  <option [ngValue]="null">Choose staff...</option>
                  <optgroup label="Available Staff" *ngIf="selectedDate && selectedTime && getAvailableStaffForService(selectedService.serviceId).length > 0">
                  <option
                    *ngFor="
                      let staff of getAvailableStaffForService(
                        selectedService.serviceId
                      )
                    "
                    [ngValue]="staff.id"
                  >
                      {{ getStaffDisplayName(staff) }}
                    </option>
                  </optgroup>
                  <optgroup label="All Staff" *ngIf="!selectedDate || !selectedTime">
                    <option
                      *ngFor="let staff of staffs"
                      [ngValue]="staff.id"
                    >
                      {{ getStaffDisplayName(staff) }}
                    </option>
                  </optgroup>
                  <optgroup label="Unavailable Staff" *ngIf="hasUnavailableStaffForService(selectedService.serviceId)">
                    <option
                      *ngFor="let staff of getUnavailableStaffForService(selectedService.serviceId)"
                      [ngValue]="staff.id"
                      [disabled]="true"
                    >
                      {{ getStaffDisplayName(staff) }}
                      <span *ngIf="!isStaffWorkingAtTime(staff, selectedDate, selectedTime, selectedService.duration)">(Not working)</span>
                      <span *ngIf="isStaffWorkingAtTime(staff, selectedDate, selectedTime, selectedService.duration) && staffAvailability.get(staff.id) === false">(Busy)</span>
                  </option>
                  </optgroup>
                </select>
                <small
                  *ngIf="!selectedDate || !selectedTime"
                  class="text-light-white fs-11 d-block mt-1"
                >
                  Please select date and time first
                </small>
                <small
                  *ngIf="isLoadingAvailability && selectedDate && selectedTime"
                  class="text-light-white fs-11 d-block mt-1"
                >
                  Checking staff availability...
                </small>
                <small
                  *ngIf="selectedDate && selectedTime && !isLoadingAvailability && getAvailableStaffForService(selectedService.serviceId).length === 0 && staffs.length > 0"
                  class="text-warning fs-11 d-block mt-1"
                >
                  No staff available at this time. Staff may be off-duty or have existing appointments. Please select a different time.
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Continue to Checkout Button -->
        <button
          type="button"
          class="btn btn-primary text-custom-white full-width fw-500 mt-3"
          [disabled]="!canProceedToCheckout()"
          (click)="proceedToCheckout()"
          (touchend)="proceedToCheckout(); $event.preventDefault()"
          style="cursor: pointer; position: relative; z-index: 10;"
        >
          Continue to Appointment Booking
        </button>
      </div>
    </div>
  </div>

  <!-- Cart Section -->
  <div class="cart-detail-box" style="position: relative; z-index: 1000;">
    <div class="card">
      <div class="card-header padding-15 fw-700">Your Order</div>
      <div class="card-body no-padding" id="scrollstyle-4">
        <!-- Empty Cart -->
        <div
          *ngIf="isCartEmpty$ | async"
          class="text-center"
          style="padding: 40px"
        >
          <p class="text-light-black">Your cart is empty</p>
        </div>

        <!-- Cart Items by Store -->
        <ng-container *ngFor="let storeCart of storeCarts$ | async">
          <div
            *ngIf="storeCart.storeName"
            class="store-cart-header padding-15"
            style="background-color: #f5f5f5; border-bottom: 1px solid #ddd"
          >
            <h6 class="text-light-black fw-700 mb-0">
              {{ storeCart.storeName }}
            </h6>
          </div>
          <div *ngFor="let item of storeCart.items" class="cat-product-box">
            <div class="cat-product">
              <div class="cat-name">
                <a href="javascript:void(0)">
                  <p class="text-light-green fw-700">
                    <span class="text-dark-white">1</span>
                    {{ getItemDescription(item) }}
                  </p>
                  <span class="text-light-white fw-700" *ngIf="item.date">
                    {{ formatDate(item.date) }} at
                    {{ formatTime(item.startTime) }}
                  </span>
                  <span class="text-light-white fw-700" *ngIf="item.staffName">
                    Staff: {{ item.staffName }}
                  </span>
                  <span class="text-light-white fw-700" *ngIf="item.duration">
                    Duration: {{ item.duration }} min
                  </span>
                </a>
              </div>
              <div class="delete-btn">
                <a
                  href="javascript:void(0)"
                  class="text-dark-white"
                  (click)="removeCartItem(storeCart.storeId, item.id)"
                  (touchend)="removeCartItem(storeCart.storeId, item.id); $event.preventDefault()"
                  title="Remove item"
                  style="cursor: pointer; padding: 10px;"
                >
                  <i class="far fa-trash-alt"></i>
                </a>
              </div>
              <div class="price">
                <a href="javascript:void(0)" class="text-dark-white fw-500">
                  {{ formatPrice(item.totalPrice) }}
                </a>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="item-total" *ngIf="!(isCartEmpty$ | async)">
          <div class="total-price border-0">
            <span class="text-dark-white fw-700">Items subtotal:</span>
            <span class="text-dark-white fw-700">{{
              cartTotalPrice$ | async | currency : "USD" : "symbol" : "1.2-2"
            }}</span>
          </div>
          <div class="empty-bag padding-15 fw-700">
            <a href="javascript:void(0)" (click)="clearCart()" (touchend)="clearCart(); $event.preventDefault()" style="cursor: pointer;">Empty bag</a>
          </div>
        </div>
      </div>
      <div class="card-footer padding-15" *ngIf="!(isCartEmpty$ | async)">
        <button
          type="button"
          (click)="proceedToCheckout()"
          (touchend)="proceedToCheckout(); $event.preventDefault()"
          class="btn btn-primary text-custom-white full-width fw-500"
          style="cursor: pointer; position: relative; z-index: 10;"
        >
          Proceed to Appointment Booking
        </button>
      </div>
    </div>
  </div>
</div>
